import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { X, ChevronLeft, ChevronRight, Maximize2 } from 'lucide-react';
import { Dialog, DialogContent } from './ui/dialog';

const PROPERTY_PHOTOS = [
  { src: 'https://customer-assets.emergentagent.com/job_b06f7103-614a-40d0-b0be-da5d75ce1ae0/artifacts/h32szhtw_Property%20Drone%20view.jpg', title: 'Aerial View', span: 'col-span-2 row-span-2' },
  { src: 'https://customer-assets.emergentagent.com/job_b06f7103-614a-40d0-b0be-da5d75ce1ae0/artifacts/tj0tgs3n_Recieption.jpg', title: 'Reception', span: 'col-span-2 row-span-1' },
  { src: 'https://customer-assets.emergentagent.com/job_b06f7103-614a-40d0-b0be-da5d75ce1ae0/artifacts/qovpgpec_rooftop%20pavilion.jpg', title: 'Rooftop Pavilion', span: 'col-span-2 row-span-1' },
  { src: 'https://customer-assets.emergentagent.com/job_b06f7103-614a-40d0-b0be-da5d75ce1ae0/artifacts/puclofbi_Bistro.jpg', title: 'The Bistro Courtyard', span: 'col-span-1 row-span-1' },
  { src: 'https://customer-assets.emergentagent.com/job_b06f7103-614a-40d0-b0be-da5d75ce1ae0/artifacts/w9hwz968_Property%20%20Backview.jpg', title: 'Property Back View', span: 'col-span-1 row-span-1' },
  { src: 'https://customer-assets.emergentagent.com/job_b06f7103-614a-40d0-b0be-da5d75ce1ae0/artifacts/pzodz223_Big%20Foot%20Cafe.jpg', title: 'Big Foot Veg Cafe', span: 'col-span-2 row-span-2' },
  { src: 'https://customer-assets.emergentagent.com/job_b06f7103-614a-40d0-b0be-da5d75ce1ae0/artifacts/87q7bbuw_1st%20floor%20view.jpg', title: 'First Floor Walkway', span: 'col-span-2 row-span-1' },
  { src: 'https://customer-assets.emergentagent.com/job_b06f7103-614a-40d0-b0be-da5d75ce1ae0/artifacts/egi6cvlh_Cafe%201.jpg', title: 'Garden Cafe Nook', span: 'col-span-1 row-span-1' },
  { src: 'https://customer-assets.emergentagent.com/job_b06f7103-614a-40d0-b0be-da5d75ce1ae0/artifacts/0xqr0png_Cafe%205.jpg', title: 'Cafe Terrace Seating', span: 'col-span-1 row-span-1' },
  { src: 'https://customer-assets.emergentagent.com/job_b06f7103-614a-40d0-b0be-da5d75ce1ae0/artifacts/qd7rig37_Property.jpg', title: 'The Property', span: 'col-span-2 row-span-1' },
];

const ROOM_PHOTOS = [
  { src: 'https://customer-assets.emergentagent.com/job_b06f7103-614a-40d0-b0be-da5d75ce1ae0/artifacts/qbox1mqd_Room%20no%201%20Drona%201.jpg', title: 'Drona · Deluxe', span: 'col-span-2 row-span-2' },
  { src: 'https://customer-assets.emergentagent.com/job_b06f7103-614a-40d0-b0be-da5d75ce1ae0/artifacts/lkf9mtk8_Room%20no%208%20Bheema%201.jpg', title: 'Bheema · Couple', span: 'col-span-2 row-span-1' },
  { src: 'https://customer-assets.emergentagent.com/job_b06f7103-614a-40d0-b0be-da5d75ce1ae0/artifacts/xk87abfx_Room%20no%205%20Lakshman%201.jpg', title: 'Lakshman · Standard', span: 'col-span-1 row-span-1' },
  { src: 'https://customer-assets.emergentagent.com/job_b06f7103-614a-40d0-b0be-da5d75ce1ae0/artifacts/gist33gc_Room%20no%202%20Arjuna%201.jpg', title: 'Arjuna · Deluxe', span: 'col-span-1 row-span-1' },
  { src: 'https://customer-assets.emergentagent.com/job_b06f7103-614a-40d0-b0be-da5d75ce1ae0/artifacts/zum6rl3w_Room%20no%207%20Sarathi%201.jpg', title: 'Sarathi · Standard', span: 'col-span-2 row-span-1' },
  { src: 'https://customer-assets.emergentagent.com/job_b06f7103-614a-40d0-b0be-da5d75ce1ae0/artifacts/pdp44rxc_Room%20no%206%20Vinayakan%201.jpg', title: 'Vinayakan · Standard', span: 'col-span-1 row-span-1' },
  { src: 'https://customer-assets.emergentagent.com/job_b06f7103-614a-40d0-b0be-da5d75ce1ae0/artifacts/ss0nqvwk_Room%20no%207%20Abhimanyu%201.jpg', title: 'Abhimanyu · Deluxe', span: 'col-span-1 row-span-1' },
  { src: 'https://customer-assets.emergentagent.com/job_b06f7103-614a-40d0-b0be-da5d75ce1ae0/artifacts/tc1ep8st_Room%20no%209%20Balraman%201.jpg', title: 'Balaraman · Couple', span: 'col-span-2 row-span-1' },
];

const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [activeCategory, setActiveCategory] = useState('property');

  const currentImages = activeCategory === 'property' ? PROPERTY_PHOTOS : ROOM_PHOTOS;

  const open = (i) => { setCurrentIndex(i); setSelectedImage(currentImages[i]); };
  const nav = (dir) => {
    const i = dir === 'next' ? (currentIndex + 1) % currentImages.length : (currentIndex - 1 + currentImages.length) % currentImages.length;
    setCurrentIndex(i); setSelectedImage(currentImages[i]);
  };

  return (
    <section id="gallery" className="relative bg-[#0B0F0E] py-32 md:py-44" data-testid="gallery-section">
      <div className="max-w-[1480px] mx-auto px-6 md:px-12">

        <div className="grid grid-cols-12 gap-6 mb-14 md:mb-20">
          <div className="col-span-12 lg:col-span-3">
            <div className="overline">Chapter IV</div>
            <div className="numeral text-7xl md:text-8xl text-[#D4AF37]/30 mt-4">04</div>
          </div>
          <div className="col-span-12 lg:col-span-9 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <motion.h2
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
              className="font-serif text-4xl md:text-6xl lg:text-7xl font-light text-[#E8E3D9] leading-[1.05]"
            >
              In <span className="italic text-[#D4AF37]">frames.</span>
            </motion.h2>
            <div className="flex gap-2">
              <button
                onClick={() => setActiveCategory('property')}
                className={`px-5 py-2.5 text-[11px] tracking-[0.2em] uppercase border transition-all ${
                  activeCategory === 'property'
                    ? 'bg-[#D4AF37] text-[#0B0F0E] border-[#D4AF37]'
                    : 'border-[#D4AF37]/30 text-[#C4BFB1] hover:border-[#D4AF37]'
                }`}
                data-testid="gallery-property-btn"
              >
                Property
              </button>
              <button
                onClick={() => setActiveCategory('rooms')}
                className={`px-5 py-2.5 text-[11px] tracking-[0.2em] uppercase border transition-all ${
                  activeCategory === 'rooms'
                    ? 'bg-[#D4AF37] text-[#0B0F0E] border-[#D4AF37]'
                    : 'border-[#D4AF37]/30 text-[#C4BFB1] hover:border-[#D4AF37]'
                }`}
                data-testid="gallery-rooms-btn"
              >
                Rooms
              </button>
            </div>
          </div>
        </div>

        {/* bento grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 grid-flow-row auto-rows-[180px] md:auto-rows-[220px] gap-3 md:gap-4">
          {currentImages.map((image, index) => (
            <motion.div
              key={`${activeCategory}-${index}`}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: (index % 8) * 0.05 }}
              onClick={() => open(index)}
              className={`relative cursor-pointer overflow-hidden group ${image.span} border border-[#D4AF37]/10 hover:border-[#D4AF37]/40 transition-all`}
              data-testid={`gallery-image-${index}`}
            >
              <img
                src={image.src}
                alt={image.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F0E]/90 via-transparent to-transparent" />
              <div className="absolute inset-0 bg-[#D4AF37]/0 group-hover:bg-[#D4AF37]/10 transition-colors duration-500" />

              <div className="absolute inset-x-0 bottom-0 p-4 flex items-end justify-between">
                <div className="font-serif text-[#E8E3D9] text-base md:text-lg italic">{image.title}</div>
                <Maximize2 size={14} className="text-[#D4AF37] opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            </motion.div>
          ))}
        </div>

        {activeCategory === 'rooms' && (
          <p className="text-center text-[11px] tracking-[0.2em] uppercase text-[#8E9A95] mt-10 italic">
            A glimpse of our nine rooms · explore all in the Rooms section
          </p>
        )}

        <Dialog open={!!selectedImage} onOpenChange={() => setSelectedImage(null)}>
          <DialogContent className="max-w-5xl bg-[#0B0F0E] border-[#D4AF37]/40 p-0">
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-4 right-4 z-10 w-9 h-9 rounded-full bg-[#0B0F0E]/80 border border-[#D4AF37]/30 text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#0B0F0E] flex items-center justify-center transition-all"
              aria-label="Close"
            >
              <X size={18} />
            </button>
            {selectedImage && (
              <div className="relative">
                <img src={selectedImage.src} alt={selectedImage.title} className="w-full h-auto max-h-[80vh] object-contain" />
                <button onClick={() => nav('prev')} className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-[#0B0F0E]/70 border border-[#D4AF37]/30 text-[#D4AF37] flex items-center justify-center hover:bg-[#D4AF37] hover:text-[#0B0F0E] transition-all" aria-label="Previous">
                  <ChevronLeft size={20} />
                </button>
                <button onClick={() => nav('next')} className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-[#0B0F0E]/70 border border-[#D4AF37]/30 text-[#D4AF37] flex items-center justify-center hover:bg-[#D4AF37] hover:text-[#0B0F0E] transition-all" aria-label="Next">
                  <ChevronRight size={20} />
                </button>
                <div className="absolute bottom-0 inset-x-0 p-5 bg-gradient-to-t from-[#0B0F0E] to-transparent">
                  <div className="font-serif text-xl text-[#E8E3D9] italic">{selectedImage.title}</div>
                  <div className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37] mt-1">{currentIndex + 1} / {currentImages.length}</div>
                </div>
              </div>
            )}
          </DialogContent>
        </Dialog>
      </div>
    </section>
  );
};

export default GallerySection;
